const WORDS = ["vehicles", "trailers", "fleets", "equipment", "tools", "luggage", "bikes", "everyday essentials"];

const EditorialMarquee = () => (
  <section
    data-testid="editorial-marquee"
    className="marquee-paused overflow-hidden border-y border-black/5 bg-white py-10"
    aria-hidden="true"
  >
    <div className="animate-marquee-slow flex w-max items-center gap-8 whitespace-nowrap">
      {[...Array(2)].map((_, dup) => (
        <div key={dup} className="flex items-center gap-8">
          {WORDS.map((w, i) => (
            <span key={w} className="flex items-center gap-8">
              <span
                className={`font-heading text-4xl font-extrabold tracking-tight sm:text-6xl ${
                  i % 2 === 0 ? "text-tracksy-ink" : "text-outline"
                }`}
              >
                track your {w}
              </span>
              <span className="h-3 w-3 rounded-full bg-tracksy-orange" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </section>
);

export default EditorialMarquee;
